var React = require('react');

function FacebookCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a,.d{fill:none;}.a{stroke:#1d2340;}.b{fill:#1d2340;}.c{stroke:none;}")),React.createElement("g",{"className":"a","key":1},[React.createElement("circle",{"className":"c","cx":"16","cy":"16","r":"16","key":0}),React.createElement("circle",{"className":"d","cx":"16","cy":"16","r":"15.5","key":1})]),React.createElement("path",{"className":"b","d":"M7.615,6.75l.333-2.172H5.865V3.169A1.086,1.086,0,0,1,7.089,2h.947V.147A11.553,11.553,0,0,0,6.355,0,2.651,2.651,0,0,0,3.517,2.923V4.578H1.609V6.75H3.517V12H5.865V6.75Z","transform":"translate(11.391 10)","key":2})]);
}

FacebookCircle.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = FacebookCircle;

FacebookCircle.default = FacebookCircle;
